import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal, Button } from '@components/ui';
import CompanySelector from '@components/shared/CompanySelector';
import { suTesisatiKategorileri } from '@mocks/materials/suTesisati';
import { mockCompanies } from '@mocks/firmalar';
import { calculateKDV, DEFAULT_KDV_RATE } from '@utils/kdv';
import KDVSummary from '../../components/KDVSummary';

export default function SuTesisatiModal({ isOpen, onClose, onSubmit, onMaterialSubmit, submitLabel, initialData = null, isLoading = false }) {
    const isEdit = !!initialData;
    const [selectedCompany, setSelectedCompany] = useState(
        initialData?.supplierId ? { id: initialData.supplierId, name: initialData.tedarikci } : null
    );
    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm({
        defaultValues: initialData || { siparisTarihi: new Date().toISOString().split('T')[0], kategori: 'boru', durum: 'bekliyor', kdvOrani: DEFAULT_KDV_RATE },
    });

    const watchedBirimFiyat = watch('birimFiyat');
    const watchedMiktar = watch('miktar');
    const watchedKdvOrani = watch('kdvOrani');

    const handleFormSubmit = (data) => {
        const result = calculateKDV({ unitPrice: data.birimFiyat, quantity: data.miktar, vatRate: data.kdvOrani });
        data.toplamFiyat = result.toplamHaric;
        data.kdvDahilToplam = result.toplamDahil;
        data.stokMiktar = data.stokMiktar || data.miktar;
        data.tedarikci = selectedCompany?.name || data.tedarikci;
        data.supplierId = selectedCompany?.id || null;

        const enriched = {
            ...data,
            selectedCompany,
            calculatedTotal: data.kdvDahilToplam,
            autoDescription: `Su Tesisatı — ${data.miktar} m ${data.kategori}`,
        };

        if (onMaterialSubmit) {
            onMaterialSubmit(enriched);
        } else {
            onSubmit(enriched, isEdit);
        }
    };

    const inputClass = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";

    return (
        <Modal isOpen={isOpen} onClose={() => { reset(); onClose(); }} title={isEdit ? 'Su Tesisatı Düzenle' : 'Yeni Su Tesisatı Malzemesi'} size="lg"
            footer={<><Button variant="ghost" onClick={() => { reset(); onClose(); }} disabled={isLoading}>İptal</Button><Button variant="primary" onClick={handleSubmit(handleFormSubmit)} isLoading={isLoading}>{submitLabel || (isEdit ? 'Güncelle' : 'Kaydet')}</Button></>}>
            <form className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <CompanySelector value={selectedCompany} onChange={setSelectedCompany} companies={mockCompanies} label="Tedarikçi / Firma" />
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Sipariş Tarihi</label><input type="date" {...register('siparisTarihi')} className={inputClass} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Kategori <span className="text-error">*</span></label>
                        <select {...register('kategori', { required: true })} className={inputClass}>{suTesisatiKategorileri.map(k => <option key={k.key} value={k.key}>{k.label}</option>)}</select></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Ürün Adı <span className="text-error">*</span></label>
                        <input type="text" {...register('urunAdi', { required: true })} placeholder="Ürün adı" className={`${inputClass} ${errors.urunAdi ? 'border-error' : ''}`} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Miktar <span className="text-error">*</span></label><input type="number" {...register('miktar', { required: true, valueAsNumber: true })} placeholder="0" className={inputClass} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Birim</label><select {...register('birim')} className={inputClass}><option value="mt">mt</option><option value="adet">Adet</option></select></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Birim Fiyat (₺)</label><input type="number" {...register('birimFiyat', { valueAsNumber: true })} placeholder="0" className={inputClass} /></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">KDV Oranı (%)</label><input type="number" step="1" {...register('kdvOrani', { valueAsNumber: true })} placeholder="20" className={inputClass} /></div>
                    <div><label className="block text-sm font-medium text-text-primary mb-1.5">Durum</label><select {...register('durum')} className={inputClass}><option value="bekliyor">Bekliyor</option><option value="teslim">Teslim Edildi</option></select></div>
                </div>
                <KDVSummary unitPrice={watchedBirimFiyat} quantity={watchedMiktar} vatRate={watchedKdvOrani} />
            </form>
        </Modal>
    );
}
